var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"983364d4259ce4c3ec9f54b2b9e77ae7cff7879e"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["react-central-europe@travpro-mobile"]={id:"983364d4259ce4c3ec9f54b2b9e77ae7cff7879e"};
      